<template>
  <v-row class="pt-9 mb-10">
    <v-col cols="12" sm="6">
      <h3 class="gray--text mb-8 mb-md-0">RELACIONAMENTO SEGURADORA</h3>
    </v-col>
    <v-col cols="6" sm="3" class="offset-sm-3">
      <BaseButton
        class="secondary text-uppercase subtitle-2 font-weight-bold mb-10 mb-sm-0"
        width="100%"
        @click="$emit('open-contact-modal')"
      >
        <v-icon class="pr-4 add-icon">fa-plus</v-icon>
        INCLUIR NOVO
      </BaseButton>
    </v-col>
    <v-col cols="12" class="mt-4">
      <BaseDataTable
        :headers="tableHeaders"
        :items="value"
        hide-pagination
        @click:row="$emit('edit-contact', $event)"
      >
        <template v-slot:[`item.id`]="{ item }">
          <BaseButton
            color="secondary"
            class="px-0 form__button-data-table"
            @click="removeItemList(item)"
          >
            <img :src="require('@/assets/ic_trash.svg')" />
          </BaseButton>
        </template>
      </BaseDataTable>
      <BaseErrorMessages
        v-if="errorMessages.length > 0"
        :error-messages="errorMessages"
      />
    </v-col>
  </v-row>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";

const tableHeaders = [
  { text: "Nome", value: "nome", sortable: false },
  { text: "E-mail", value: "email", sortable: false },
  { text: "Telefone", value: "telefone1", sortable: false },
  { text: "Departamento", value: "departamento", sortable: false }
];

export default {
  name: "InsuranceContactSelection",
  props: {
    value: {
      type: Array
    },
    errorMessages: {
      type: Array
    }
  },
  data: () => ({
    requiredInput,
    tableHeaders
  }),
  methods: {
    removeItemList(item) {
      const index = this.value.indexOf(item);
      this.value.splice(index, 1);
    }
  }
};
</script>
